import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import BookingForm from './components/Booking/BookingForm';
import AdminDashboard from './components/Admin/AdminDashboard';
import Dashboard from './components/Dashboard';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <Router>
      <Header />
      <main className="p-4">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Dashboard />} /> {/* Default route for logged in users */}
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/book" element={<PrivateRoute><BookingForm /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
          {/* Add a success/cancel page for Stripe if needed */}
          <Route path="/success" element={<div className="text-center text-green-600 text-2xl mt-8">Payment Successful!</div>} />
          <Route path="/cancel" element={<div className="text-center text-red-600 text-2xl mt-8">Payment Cancelled.</div>} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;